module.exports = __webpack_public_path__ + "img/经济法.3d78367a.png";